import React, {useState} from 'react'
import {Block, Row} from 'jsxstyle'
import {useCopilotContext} from '../CopilotContext'
import {ReactComponent as EditTitleIcon} from '../../../common/assets/edit-icon.svg'

const ChatHeader = () => {
  const {selectedConversation, setSelectedConversation, updateConversation} = useCopilotContext()
  const [isEditing, setIsEditing] = useState(false)
  const [newTitle, setNewTitle] = useState('')

  const handleEditClick = () => {
    setNewTitle(selectedConversation?.title || 'Untitled Conversation')
    setIsEditing(true)
  }

  const handleSaveTitle = async () => {
    if (selectedConversation) {
      await updateConversation(selectedConversation.id, newTitle || 'Untitled Conversation')
    }
    setIsEditing(false)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSaveTitle()
    } else if (e.key === 'Escape') {
      setIsEditing(false)
    }
  }

  return (
    <Row alignItems="center" padding="12px 16px" borderBottom="1px solid #eaeaea" width="100%">
      <Block
        component="button"
        props={{
          onClick: () => {
            setSelectedConversation(undefined)
          },
        }}
        marginRight="12px"
        cursor="pointer"
        background="none"
        border="none"
        padding="4px 8px"
        borderRadius="4px"
        hoverBackgroundColor="#f5f5f5"
      >
        ←
      </Block>

      {isEditing ? (
        <input
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
          onBlur={handleSaveTitle}
          onKeyDown={handleKeyDown}
          autoFocus
          style={{
            fontSize: '14px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '4px',
            border: '1px solid #0070f3',
            outline: 'none',
            width: '100%',
            maxWidth: '300px',
          }}
        />
      ) : (
        <Row alignItems="center" width="80%" justifyContent="space-between">
          <Block flex="1" fontSize="14px" fontWeight={500} marginRight="8px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
            {selectedConversation?.title || 'Untitled Conversation'}
          </Block>

          <Block
            component="button"
            props={{onClick: handleEditClick}}
            cursor="pointer"
            background="none"
            border="none"
            padding="4px"
            borderRadius="4px"
            hoverBackgroundColor="#f5f5f5"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <EditTitleIcon width={16} height={16} />
          </Block>
        </Row>
      )}
    </Row>
  )
}

export default ChatHeader
